import React from 'react';
import { InputNumber as AntdInputNumber } from 'antd';
import type { InputNumberProps as AntdInputNumberProps } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import './InputNumber.css';

export interface WxbInputNumberProps extends AntdInputNumberProps { label?: string; error?: string; }

export const WxbInputNumber: React.FC<WxbInputNumberProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdInputNumber
        {...props}
        id={controlId}
        className={`wxb-input-number ${error ? 'wxb-in-error' : ''} ${className}`}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
